export class CreateOrganizationIdpGroupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idpId",
            "baseName": "idpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerGroupId",
            "baseName": "providerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleGrants",
            "baseName": "roleGrants",
            "type": "Array<OrganizationRoleGrant>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOrganizationIdpGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
